import { useState } from 'react';
import { Content } from 'src/contexts/ContentContext';
import { PosCurrencyField } from 'src/core/POS/PosCurrencyField';
import { vars } from 'src/core/themes';
import { Button, Stack } from 'src/core/ui';
import { TargetIcon } from 'src/svgs/TargetIcon';
import { ContentId } from 'src/utils/constants/contentId';

import { DashboardSectionWrapper } from '../DashboardSectionWrapper';
import { useDataInsights } from './DataInsightsContext';

export const TargetInput = ({
  targetValue,
  setTargetValue,
}: {
  targetValue: number | null;
  setTargetValue: (value: number | null) => void;
}) => {
  const { uiCurrency } = useDataInsights();
  const [updatingInput, setUpdatingInput] = useState(false);
  const [localTargetValue, setLocalTargetValue] = useState<number | null>(
    targetValue
  );
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: uiCurrency.code,
  });

  if (updatingInput) {
    return (
      <DashboardSectionWrapper fixed>
        <Stack gap="m" style={{ width: '200px', marginTop: '18px' }}>
          <PosCurrencyField
            value={localTargetValue || ''}
            onChange={(e) => {
              const newValue = e.target.value ? parseInt(e.target.value) : null;
              setLocalTargetValue(newValue);
            }}
            uiCurrency={uiCurrency}
          />
          <Button
            onClick={() => {
              setUpdatingInput(false);
              setTargetValue(localTargetValue);
            }}
          >
            <Content id={ContentId.Save} />
          </Button>
        </Stack>
      </DashboardSectionWrapper>
    );
  }
  return (
    <DashboardSectionWrapper fixed>
      <div style={{ marginTop: '18px' }}>
        {localTargetValue ? (
          <Button
            onClick={() => setUpdatingInput(true)}
            variant="outline"
            shape="rect"
            size="md"
            style={{
              backgroundColor: vars.color.backgroundBrandHoverLight,
              border: 'none',
              padding: '12px',
            }}
          >
            <TargetIcon width={20} height={20} fill={vars.color.textBrand} />
            <div>{currencyFormatter.format(localTargetValue)}</div>
            <Content id={ContentId.Update} />
          </Button>
        ) : (
          <Button onClick={() => setUpdatingInput(true)} variant="outline">
            <Content id={ContentId.SetTarget} />
          </Button>
        )}
      </div>
    </DashboardSectionWrapper>
  );
};
